import { render, staticRenderFns } from "./SelosVinculados.vue?vue&type=template&id=5a41b7d8&scoped=true&"
import script from "./SelosVinculados.vue?vue&type=script&lang=js&"
export * from "./SelosVinculados.vue?vue&type=script&lang=js&"
import style0 from "./SelosVinculados.vue?vue&type=style&index=0&id=5a41b7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41b7d8",
  null
  
)

export default component.exports